import { Store } from "../../../../@core/store/store";

export class RequestsForApprovalsLoadingState extends Store.AbstractLoadingState<any> { }
export class RequestsForApprovalsLoadingErrorState extends Store.AbstractErrorState<any> { }
export class RequestsForApprovalsLoadedState extends Store.AbstractIdealState<any> { }

export class FeedsDataLoadingState extends Store.AbstractLoadingState<any> { }
export class FeedsDataLoadingErrorState extends Store.AbstractErrorState<any> { }
export class FeedsDataLoadedState extends Store.AbstractIdealState<any> { }

export class MyOrgDataLoadingState extends Store.AbstractLoadingState<any> { }
export class MyOrgDataLoadingErrorState extends Store.AbstractErrorState<any> { }
export class MyOrgDataLoadedState extends Store.AbstractIdealState<any> { }

export class MyOrgMonthDataLoadingState extends Store.AbstractLoadingState<any> { }
export class MyOrgMonthDataLoadingErrorState extends Store.AbstractErrorState<any> { }
export class MyOrgMonthDataLoadedState extends Store.AbstractIdealState<any> { }

export class MyAttendanceDataLoadingState extends Store.AbstractLoadingState<any> { }
export class MyAttendanceDataLoadingErrorState extends Store.AbstractErrorState<any> { }
export class MyAttendanceDataLoadedState extends Store.AbstractIdealState<any> { }


export class MyTeamsDataLoadingState extends Store.AbstractLoadingState<any> { }
export class MyTeamsDataLoadingErrorState extends Store.AbstractErrorState<any> { }
export class MyTeamsDataLoadedState extends Store.AbstractIdealState<any> { }

export class CMSFeedsLoadingState extends Store.AbstractLoadingState<any> { }
export class CMSFeedsLoadingErrorState extends Store.AbstractErrorState<any> { }
export class CMSFeedsLoadedState extends Store.AbstractIdealState<any> { }

export class ApproveRequestLoadingState extends Store.AbstractLoadingState<any> { }
export class ApproveRequestLoadingErrorState extends Store.AbstractErrorState<any> { }
export class ApproveRequestLoadedState extends Store.AbstractIdealState<any> { }

export class DeclineRequestLoadingState extends Store.AbstractLoadingState<any> { }
export class DeclineRequestLoadingErrorState extends Store.AbstractErrorState<any> { }
export class DeclineRequestLoadedState extends Store.AbstractIdealState<any> { }

export class ForexRequestLoadingState extends Store.AbstractLoadingState<any> { }
export class ForexRequestLoadingErrorState extends Store.AbstractErrorState<any> { }
export class ForexRequestLoadedState extends Store.AbstractIdealState<any> { }

export class UpdateWidgetOrderLoadingState extends Store.AbstractLoadingState<any> { }
export class UpdateWidgetOrderLoadingErrorState extends Store.AbstractErrorState<any> { }
export class UpdateWidgetOrderLoadedState extends Store.AbstractIdealState<any> { }

export class UpcomingLeavesDataLoadingState extends Store.AbstractLoadingState<any> { }
export class UpcomingLeavesDataLoadingErrorState extends Store.AbstractErrorState<any> { }
export class UpcomingLeavesDataLoadedState extends Store.AbstractIdealState<any> { }

export class MyDailyAttendanceDataLoadingState extends Store.AbstractLoadingState<any> { }
export class MyDailyAttendanceDataLoadingErrorState extends Store.AbstractErrorState<any> { }
export class MyDailyAttendanceDataLoadedState extends Store.AbstractIdealState<any> { }

export class DailyAttendanceDataLoadingState extends Store.AbstractLoadingState<any> { }
export class DailyAttendanceDataLoadingErrorState extends Store.AbstractErrorState<any> { }
export class DailyAttendanceDataLoadedState extends Store.AbstractIdealState<any> { }